<template>
  <v-list>
    <ConfirmDialog
      :is-open.sync="isRowDialogOpen"
      width="400"
      confirm-button-text="Add"
      @cancel="closeRowDialog"
      @confirm="addChosenRow"
    >
      <template v-slot:title>
        Chose new row template
      </template>
      <template v-slot:body>
        <v-list>
          <v-list-item-group
            v-model="chosenTypeNum"
            mandatory
            color="rgba(132, 176, 112, 1)"
            active-class="selector-active-class"
          >
            <v-list-item
              v-for="rowType in rowDialogRowTypes"
              :key="rowType.type"
              class="pa-0 pl-6 my-2"
              :style="{ alignItems: 'stretch' }"
            >
              <div
                v-if="rowType.type === 'one_image'"
                 class="ma-0 pa-0 row-selector"
              >
                <div
                  class="element element--image element--single"
                >
                  Image
                </div>
              </div>
              <div
                v-else-if="rowType.type === 'one_text'"
                class="ma-0 pa-0 row-selector"
              >
                <div
                  class="element element--text element--single"
                >
                  Text
                </div>
              </div>
              <div
                v-else-if="rowType.type === 'image_text'"
                class="ma-0 pa-0 row-selector"
              >
                <div
                  class="element element--image element--small"
                >Image</div>
                <div
                  class="element element--text element--big"
                >Text</div>
              </div>
              <div
                v-else-if="rowType.type === 'text_image'"
                class="ma-0 pa-0 row-selector"
              >
                <div
                  class="element element--text element--big"
                >Text</div>
                <div
                  class="element element--image element--small"
                >Image</div>
              </div>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </template>
    </ConfirmDialog>

    <v-list-item
        v-if="!isLeadImageExists"
        class="cyan lighten-5"
        link
        @click="addLeadImage()"
    >
      <v-list-item-action
          class="mx-auto"
      >
        ADD LEAD IMAGE
      </v-list-item-action>
    </v-list-item>

    <v-divider/>

    <v-list-item
      link
      @click="callRowDialog(firstBodyElementIndex)"
    >
      <v-list-item-action
        class="mx-auto"
      >
        ADD ROW
      </v-list-item-action>
    </v-list-item>

    <v-divider/>

    <template v-for="(rowData, rowIndex) in micrositeBody">
      <DynamicRow
        :key="rowIndex"
        :row-index="rowIndex"
        :row-data="rowData"
      />
      <v-divider
        :key="`d${rowIndex}`"
      />
    </template>

    <v-list-item
      link
      @click="callRowDialog(micrositeBody.length)"
    >
      <v-list-item-action
        class="mx-auto"
      >
        ADD ROW
      </v-list-item-action>
    </v-list-item>
  </v-list>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import DynamicRow from './DynamicRow.vue';
import ConfirmDialog from '../dialogs/ConfirmDialog.vue';

export default {
  name: 'RowsList',
  components: {
    DynamicRow,
    ConfirmDialog,
  },

  props: {
  },

  data: () => ({
    chosenTypeNum: 0,
  }),

  methods: {
    ...mapActions({
      openRowDialog: 'microsite/openRowDialog',
      closeRowDialog: 'microsite/closeRowDialog',
      setRowDialogStatus: 'microsite/setRowDialogStatus',
      setRowDialogRowPosition: 'microsite/setRowDialogRowPosition',
      addRow: 'microsite/addRow',
      setLeadImageStatus: 'microsite/setLeadImageStatus',
    }),

    callRowDialog(rowPosition, substituteRow = false) {
      this.setRowDialogRowPosition(rowPosition, substituteRow);
      this.openRowDialog();
    },

    addChosenRow() {
      const rowDialogChosenType = this.rowDialogRowTypes[this.chosenTypeNum].type;

      this.addRow({ position: this.rowDialogRowPosition, rowType: rowDialogChosenType });
      this.closeRowDialog();
    },

    addLeadImage() {
      this.setRowDialogRowPosition(0);

      this.addRow({ position: this.rowDialogRowPosition, rowType: 'lead_image' });

      this.setLeadImageStatus(true);
    },
  },

  computed: {
    ...mapGetters({
      maxElements: 'microsite/maxElementsInRow',
      micrositeBody: 'microsite/body',
      firstBodyElementIndex: 'microsite/firstBodyElementIndex',
      isLeadImageExists: 'microsite/isLeadImageExists',
      rowDialogRowPosition: 'microsite/rowDialogRowPosition',
      rowDialogRowStatus: 'microsite/rowDialogStatus',
      rowDialogRowTypes: 'microsite/rowDialogTypes',
    }),

    isRowDialogOpen: {
      get() {
        return this.rowDialogRowStatus;
      },
      set(value) {
        this.setRowDialogStatus(value);
      },
    },
  },
};
</script>

<style scoped>
.selector-active-class {
  background-color: rgba(132, 176, 112, 1);
}

.row-selector {
  width: 100%;
  flex-shrink: 0;
  display: flex;
  align-items: stretch;
  justify-content: stretch;
}

.row-selector .element {
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
}

.row-selector .element--single {
  flex-grow: 1;
}

.row-selector .element--small {
  flex-grow: 1;
}

.row-selector .element--big {
  flex-grow: 2;
}

.row-selector .element--image{
  background-color: #3d66b0;
}

.row-selector .element--text{
  background-color: #e5ac00;
}
</style>
